// Wizard Nieuwe reservering — een nieuw dier: de foto of het paspoort laten uitlezen en de foto opslaan. Multipart
// met een token dat alleen in het geheugen staat, dus via fetch en niet via de Refine-dataProvider (zelfde reden
// als intakePhoto.ts). Zelfde antwoord als de inboek-wizard, maar onder /api/pension en het recht om een dier aan
// te maken.
import { getAccessToken } from "../auth";
import { AnimalPhotoApiError, type PhotoAiAnalyzeResult } from "./animalPhoto";

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "/api";

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function verstuur(url: string, file: File): Promise<Response> {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(url, { method: "POST", headers: authHeaders(), body: form });
  if (!res.ok) throw new AnimalPhotoApiError(res.status, res.statusText);
  return res;
}

/** Een foto van het dier laten uitlezen: voorstellen voor naam, chip, soort, ras, vacht en kleur. */
export async function analyseerDierFoto(file: File): Promise<PhotoAiAnalyzeResult> {
  return (await verstuur(`${API_URL}/pension/dieren/foto-analyse`, file)).json() as Promise<PhotoAiAnalyzeResult>;
}

/** "Scan foto van paspoort": dezelfde voorstellen plus de geboortedatum. */
export async function analyseerPaspoort(file: File): Promise<PhotoAiAnalyzeResult> {
  return (await verstuur(`${API_URL}/pension/dieren/paspoort-analyse`, file)).json() as Promise<PhotoAiAnalyzeResult>;
}

/** De foto opslaan als hoofdfoto van het zojuist aangemaakte dier. */
export async function bewaarDierFoto(dierId: number, file: File): Promise<void> {
  await verstuur(`${API_URL}/pension/dieren/${dierId}/foto`, file);
}
